module.exports = __webpack_public_path__ + "img/undraw_bug_fixing_oc7a.9c437b49.svg";